import { useQuery } from '@tanstack/react-query';
import useApiStore from '../../store/useApiStore';
import { ICity } from '../../types';
import { CITIES_KEY } from '../../utils/constants';
import Api from '../Api';

interface RESPONSE {
  cities: ICity[];
  stateName: string;
}

export default function useGetCities(code?: string) {
  const { onError } = useApiStore();

  return useQuery<ICity[], Error>({
    queryKey: [CITIES_KEY, code],
    queryFn: async () => {
      const api = new Api({ onError });

      const data: RESPONSE = await api.get({
        url: `api/v1/locations/states/code/${code}`,
      });

      return data.cities;
    },
    enabled: !!code,
  });
}
